module.exports = __webpack_public_path__ + "static/a0070bd5e07160810da720f4a6f72ef3816f76f67dc2ba8277818935e6f1fa57-92b6a9683a20173fa1028dc92a09cf12.jpeg";